import { atom, RecoilState } from 'recoil';
import { Patient } from 'api/models';

export const selectedPatientState: RecoilState<Patient | undefined> = atom<
  Patient | undefined
>({
  key: 'selectedPatientState',
  default: undefined,
});
